// extracted by mini-css-extract-plugin
export default {"word":"SentenceBuilderView_word__2dWUd","missing":"SentenceBuilderView_missing__eXAS7"};